
export default function avatarString(str) {
    // If the string has less than 4 characters, return it as is
    if (str.length <= 2) {
        return str.toLowerCase();
    }

    // If the string contains a space, return the first word truncated to 4 characters
    if (str.includes(' ')) {
        const firstWord = str.split(' ')[0]; 
        const secondWord = str.split(' ')[1];

        let out = ""
        if (firstWord.length > 0) {
            out += firstWord[0]
        }
        if (secondWord.length > 0) {
            out += secondWord[0]
        }
        return out
    }

    // If no space is found, return the first 4 characters of the string
    return str.slice(0, 2).toLowerCase();
}